export default "<p>vouchers works!</p>\r\n";